/* eslint-disable react/no-array-index-key */
import { Fragment, FC, useMemo } from 'react';
import { List, ListItem, Heading } from '@qga/roo-ui/components';
import { InfoModal } from 'components/Layout';
import { SelfServiceAPI } from 'types';
import { sanitizeHTML } from 'lib/utils';
import { BreakOnNewLine } from 'components/Typography';

const offerBlock = (description: string) => {
  if (!description) {
    return null;
  }

  return (
    <Fragment>
      <Heading.h4>Offer Description</Heading.h4>
      <BreakOnNewLine dangerouslySetInnerHTML={{ __html: description }} />
    </Fragment>
  );
};

const roomTypeBlock = (description: string) => {
  if (!description) {
    return null;
  }

  return (
    <Fragment>
      <Heading.h4 mt={6}>Room Description</Heading.h4>
      <BreakOnNewLine dangerouslySetInnerHTML={{ __html: description }} />
    </Fragment>
  );
};

const bedTypeBlock = (description: string | null | undefined) => {
  if (!description) {
    return null;
  }

  return (
    <Fragment>
      <Heading.h4 mt={6}>Bed Type Description</Heading.h4>
      <BreakOnNewLine dangerouslySetInnerHTML={{ __html: description }} />
    </Fragment>
  );
};

const inclusionsBlock = (inclusions: { name: string }[]) => {
  if (!inclusions || !inclusions.length) {
    return null;
  }

  return (
    <Fragment>
      <Heading.h4 mt={6}>Inclusions</Heading.h4>
      <List columns={[1, 2]}>
        {inclusions.map(({ name }) => (
          <ListItem key={name}>{name}</ListItem>
        ))}
      </List>
    </Fragment>
  );
};

interface RoomAndOfferModalProps {
  booking: SelfServiceAPI.Booking;

  [key: string]: any;
}

const RoomAndOfferModal: FC<RoomAndOfferModalProps> = ({ booking, ...modalProps }) => {
  const { offer, roomType } = booking.reservation;

  const offerDescription = useMemo(() => sanitizeHTML(offer.description), [offer.description]);
  const roomTypeDescription = useMemo(() => sanitizeHTML(roomType.description), [roomType.description]);
  const bedGroupDescription = useMemo(
    () => sanitizeHTML(booking.reservation.bedGroupDescription),
    [booking.reservation.bedGroupDescription],
  );

  return (
    <InfoModal title="Room and offer information" {...modalProps}>
      <InfoModal.body p="5" pb="10">
        {offerBlock(offerDescription)}
        {roomTypeBlock(roomTypeDescription)}
        {bedTypeBlock(bedGroupDescription)}
        {inclusionsBlock(offer.inclusions)}
      </InfoModal.body>
    </InfoModal>
  );
};

export default RoomAndOfferModal;
